// import { cloneDeep } from 'lodash';
import { cloneDeep } from 'lodash';
import moment from 'moment';

const initialState = {
	clientInvoiceId: '',
	fromStore: {},
	toStore: {},
	subject: '',
	orderId: null,
	invoiceDate: new Date(),
	dueDate: new Date(new Date().setDate(new Date().getDate() + 1)),
	items: [],
};

const reducer = (state, action) => {
	switch (action.type) {
		case 'SET_VALUE':
			return {
				...state,
				...action.payload,
			};
		case 'INIT':
			return {
				...initialState,
			};
		default:
			return state;
	}
};

const mandatoryFields = [
	{
		field: 'clientInvoiceId',
		displayName: 'Client Invoice ID',
	},
	{
		field: 'fromStore',
		displayName: 'By Store',
	},
	{
		field: 'storeId',
		displayName: 'To Store',
	},
	{
		field: 'invoiceDate',
		displayName: 'Invoice Date',
	},
	{
		field: 'dueDate',
		displayName: 'Due Date',
	},
];

const config = {
	initialState,
	reducer,
	serializer: (data) => {
		return data;
		// const newState = {
		// machineName: data?.machine_name,
		// macAddress: data?.mac,
		// store: data?.storeId,
		// process: data?.processId,
		// manufacturedOn: data?.manufactured_on
		// ? new Date(data?.manufactured_on)
		// : null,
		// installedOn: data?.installed_on
		// ? new Date(data?.installed_on)
		// : null,
		// expiresOn: data?.warranty_expires_on
		// ? new Date(data?.warranty_expires_on)
		// : null,
		// serialNo: data?.serial_number,
		// modelNo: data?.model_number,
		// };
		// return newState;
	},
	deserializer: (state) => {
		const clonedState = cloneDeep(state);
		const { toStore, ...remaining } = clonedState;
		const newState = {
			dueDate: moment(remaining?.dueDate)?.format('M/D/YYYY'),
			transactionDate: moment(remaining?.invoiceDate)?.format('M/D/YYYY'),
			fromStore: remaining?.fromStore?.id,
			storeId: toStore?.id,
			clientTransactionId: `INV-${remaining?.clientInvoiceId}`,
			orderId: remaining?.orderId,
			items: remaining?.items?.map((ele) => {
				return {
					productId: ele?.productId,
					variantId: ele?.selectedVariant?.id,
					qty: Number(ele?.quantity),
					price: Number(ele?.selectedVariant?.price),
					tax: ele?.tax,
					subTotal: ele?.subTotal,
					totalTax: ele?.totalTax,
					finalAmount: ele?.totalPriceIncTax,
				};
			}),
		};
		return newState;
	},
	validator: (state) => {
		return mandatoryFields?.find((key) => {
			return state[key?.field] === null || state[key?.field] === '';
		});
	},
};

export default config;
